<template>
                          <v-hover
                              v-slot:default="{ hover }"
                              open-delay="100"
                            >
                        <v-card  
                        tile 
                        :elevation="hover ? 16 : 2"
                        @click="gotoNews(newsFilter)"
                        >
                          <v-img
                            :src="`http://api.trcgagarinsky.ru/terminal__tmp/`+newsFilter.bannersUrl"
                            aspect-ratio="1"
                            class="grey lighten-2"
                          >
                            <v-expand-transition>
                              <v-row
                                v-if="hover"
                                class=" transition-fast-in-fast-out  v-card--reveal-ff bg-opcity-blk  white--text ma-0 "
                                style="height: 100%;"
                              >
                              <v-col style="height: 100%;" class="d-flex flex-column py-0">
                                  <v-row class=" align-start">
                                    <v-col>
                                      <div class="px-0 pb-2  mb-2 shop-action" :class="[size==='big' ? 'subtitle-2' : 'text-lg-subtitle-2 text-md-caption text-sm-caption']">{{newsFilter.nameShopAction}}</div>
                                    </v-col>
                                  </v-row>
                                  <v-row justify="center" align="center">
                                    <v-col class="py-0">
                                      <div class="  pa-0  mt-2 title-news-center" :class="[size==='big' ? 'text-lg-h4 text-md-body-2 text-sm-body-1' : 'text-lg-subtitle-2 text-md-caption text-sm-caption']">{{newsFilter.titleAction}}</div>
                                    </v-col>
                                  </v-row>
                                  <v-row justify="center" align="end">
                                    <v-col>
                                      <div class="px-0 pt-2  mt-2 date-action " :class="[size==='big' ? 'subtitle-2' : 'text-lg-subtitle-2 text-md-caption text-sm-caption']">{{newsFilter.dateaction}}</div>
                                    </v-col>
                                  </v-row>
                                  
                                  
                                  
                              </v-col>


                              </v-row>
                            </v-expand-transition>  

                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-card>
                        </v-hover>
  
</template>

<script>



export default {
  name: 'NewsBlock',
  props: ['newsFilter','size'],

  data: () => ({

  }),
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    loadPathData: {
          get () {
            return this.$store.getters.getLoadPathData
          }          
        },     
    currentNews: {
          get () {
            return this.$store.state.news.currentNews;
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentNews', val)
          }
        },
  },
  methods: {
      gotoNews(nNews){
        let vApp = this;
        if(DEBUG) console.log('nNews :', nNews);
        vApp.currentNews = nNews;
        vApp.$router.push('/'+vApp.loadPathData.mnuNewsPath+'/'+nNews.slug)
      },
  }
};
</script>
<style scoped>

.shop-action{
  color: #fff;
  border-bottom: 2px solid #fff;
}
.date-action{
  color: #fff;
border-top: 2px solid #fff;

}
.title-news-center{

  color: #fff;
  line-height: 1.0 !important;
}
.bg-opcity-blk{
  background-color: #000000dd;
}
</style>